import { As, Button, SystemStyleObject, Tooltip } from "@chakra-ui/react";
import React, { CSSProperties, ReactNode } from "react";

interface ButtonSSProps {
  buttonSS?: string;
  isLoading?: boolean;
  disabled?: boolean;
  isDisabled?: boolean;
  bg?: string | object;
  children?: ReactNode;
  color?: string | object;
  border?: string | object;
  fontSize?: string | number | object;
  fontWeight?: string | number | object;
  h?: string | object | number;
  w?: string | object | number;
  borderColor?: string | object;
  my?: string | object | number;
  mx?: string | object | number;
  mt?: string | object | number;
  mb?: string | object | number;
  ml?: string | object | number;
  mr?: string | object | number;
  py?: string | object | number;
  px?: string | object | number;
  m?: string | object | number;
  hover?: SystemStyleObject | undefined;
  tooltipLabel?: string | boolean | ReactNode;
  toolTipTextAlign?: CSSProperties['textAlign'];
  type?: 'button' | 'submit' | 'reset' | undefined;
  onClick?: React.MouseEventHandler<HTMLButtonElement> | undefined;
  leftIcon?:
    | React.ReactElement<any, string | React.JSXElementConstructor<any>>
    | undefined;
  rightIcon?:
    | React.ReactElement<any, string | React.JSXElementConstructor<any>>
    | undefined;
  rounded?: string | object | number;
  as?: As;
  cursor?: string;
  arrowSize?: string | object | number;
  display?: string | object;
  id?: string;
  size?: any;
  form?: string;
}

const ButtonSS: React.FC<ButtonSSProps> = ({
  h,
  w,
  my,
  mx,
  mb,
  mt,
  ml,
  mr,
  py,
  px,
  m,
  bg,
  type,
  hover,
  color,
  border,
  onClick,
  fontSize,
  fontWeight,
  children,
  leftIcon,
  buttonSS,
  rightIcon,
  isLoading,
  disabled,
  isDisabled,
  borderColor,
  tooltipLabel,
  toolTipTextAlign,
  rounded,
  as,
  cursor,
  display,
  id,
  size,
  form,
  // Extract custom props
  ...rest
}) => {
  return (
    <Tooltip hasArrow textAlign={toolTipTextAlign} label={tooltipLabel}>
      <Button
        h={h}
        w={w}
        my={my}
        mx={mx}
        mb={mb}
        mt={mt}
        mr={mr}
        py={py}
        px={px}
        m={m}
        ml={ml}
        bg={bg}
        type={type}
        border={border}
        borderColor={borderColor}
        _hover={hover}
        color={color}
        fontSize={fontSize}
        fontWeight={fontWeight}
        onClick={onClick}
        leftIcon={leftIcon}
        rightIcon={rightIcon}
        isLoading={isLoading}
        disabled={disabled}
        isDisabled={isDisabled}
        rounded={rounded}
        as={as}
        cursor={cursor}
        display={display}
        id={id}
        size={size}
        form={form}
        {...rest} // Spread the rest of the props
      >
        {buttonSS}
        {children}
      </Button>
    </Tooltip>
  );
};

ButtonSS.defaultProps = {
  bg: "teal.300",
  hover: { bg: "teal.400" },
  color: "white",
  fontSize: { base: "sm", md: "md" },
  toolTipTextAlign: "center",
};

export default ButtonSS;
